export function dataInRequest(params = {}) {
  return {
    type: '@veiculoMensagemTCA/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@veiculoMensagemTCA/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@veiculoMensagemTCA/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@veiculoMensagemTCA/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@veiculoMensagemTCA/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@veiculoMensagemTCA/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@veiculoMensagemTCA/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@veiculoMensagemTCA/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@veiculoMensagemTCA/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@veiculoMensagemTCA/RECORD_FILTERING',
    payload: { params },
  };
}
